import Template from "../../template/template";
import {TemplateAccess} from "../@const";


export default class TemplateAccessControl {

    private template : Template

    constructor(template:Template) {
        this.template = template
    }

    get hasAccess():boolean {
        switch (this.template.access) {
            case TemplateAccess.GOODDAY:
                return true;
            case TemplateAccess.COMPANY:
                return true;
            case TemplateAccess.PRIVATE:
                if (this.template.createdByUserId === gd.user.id) {
                    return true;
                }
        }
        return false;
    }
}
